import { toLocaleCurrency } from 'utils/dinero'

interface MeterProps {
  advanceAmount: number
  loanAmount: number
  advanceIsValid: boolean
  loanIsValid: boolean
  loanIsDepleted: boolean
  advanceIsDepleted: boolean
}

const Meter = ({
  advanceAmount,
  loanAmount,
  advanceIsValid,
  loanIsValid,
  loanIsDepleted,
  advanceIsDepleted
}: MeterProps) => {
  const isLoanGrayed = !loanIsValid || (loanAmount == 0 && !loanIsDepleted)
  const isAdvanceGrayed =
    !advanceIsValid || (advanceAmount == 0 && !advanceIsDepleted)

  return (
    <div
      className={`my-4 text-2xs rounded-full flex ${
        isLoanGrayed ? 'bg-[#F7F7FD]' : 'bg-[#29EAA5]'
      } text-center font-bold shadow-card`}
    >
      <div
        className={`rounded-full flex items-center justify-center h-10 w-full ${
          isAdvanceGrayed
            ? 'bg-[#ECECF2] text-[#4E4E4E]'
            : 'bg-blue-credit-gradient text-white'
        }`}
      >
        {advanceIsValid ? `$${toLocaleCurrency(advanceAmount)}` : 'Consultá'}
      </div>
      <div
        className={`${
          isLoanGrayed
            ? 'bg-[#F7F7FD] text-[#4E4E4E]'
            : 'bg-[#29EAA5] text-black'
        } flex items-center justify-center rounded-full h-10 w-full`}
      >
        {loanIsValid ? `$${toLocaleCurrency(loanAmount)}` : 'Consultá'}
      </div>
    </div>
  )
}

export default Meter
